/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Para crear un nuevo proyecto con Vue necesitas instalar `}<inlineCode parentName="p">{`@vue/cli`}</inlineCode>{`.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-cli"
      }}><code parentName="pre" {...{
          "className": "language-cli"
        }}>{`npm install -g @vue/cli`}</code></pre></div>
    <p>{`A continuación, con Vue tienes la opción de poder crear un prototipo rápido solamente con un archivo `}<inlineCode parentName="p">{`.js`}</inlineCode>{` o `}<inlineCode parentName="p">{`.vue`}</inlineCode>{` una vez que instales `}<inlineCode parentName="p">{`@vue/cli-service-global`}</inlineCode>{`.`}</p>
    <p>{`O puedes decidir crear una aplicación, en ese caso necesitas correr el comando:`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-cli"
      }}><code parentName="pre" {...{
          "className": "language-cli"
        }}>{`vue create mi-nueva-aplicacion`}</code></pre></div>
    <p>{`A continuación tendrás la opción de escoger entre la configuración default y una configuración personalizada a tus necesidades, con un click puedes añadir las siguientes tecnologías y sus variantes a tu proyecto:`}</p>
    <ul>
      <li parentName="ul">{`Babel`}</li>
      <li parentName="ul">{`TypeScript`}</li>
      <li parentName="ul">{`Soporte de PWA`}</li>
      <li parentName="ul">{`Router`}</li>
      <li parentName="ul">{`Vuex`}</li>
      <li parentName="ul">{`Preprocesadores CSS`}</li>
      <li parentName="ul">{`Linter`}</li>
      <li parentName="ul">{`Unit testing`}</li>
      <li parentName="ul">{`E2E testing`}</li>
    </ul>
    <p>{`Además al brindarte los archivos de configuración, puedes agregar más cosas fácilmente.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;